import React from "react";
import AutomationList from "../shared/components/AutomationList";
import { WORKFLOW_CATEGORY } from "../workflow/utils/enums";

const EmployeeReportingAutomation: React.FC = () => {
  return (
    <AutomationList
      workflowCategory={WORKFLOW_CATEGORY.EMPLOYEE_REPORTING}
      title="Employee Reporting Automation"
      breadcrumb="Employee Reporting"
      module="employee-reporting"
    />
  );
};

export default EmployeeReportingAutomation;
